import { Box, Grid } from '@mui/material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragIndicator } from '@mui/icons-material';

import { DynamicSectionDto, FormFieldDto, FormItemDto, FormItemKind } from '../document-generation.dto';
import { DocumentTemplateField } from './DocumentTemplateField';
import { DocumentTemplateSection } from './DocumentTemplateSection';

interface DocumentTemplateItemProps {
    index: number;
    item: FormItemDto;

    // only set for sections
    onUpdate?: (updated: DynamicSectionDto) => void;
    onRemove?: (section: DynamicSectionDto) => void;
    depth?: number;
}

export function SortableDocumentTemplateItem(props: DocumentTemplateItemProps) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id: props.item._id ?? props.item.key,
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        position: 'relative' as const,
    };

    return (
        <Grid size={12} sx={style} ref={setNodeRef}>
            <Box
                {...attributes}
                {...listeners}
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: -30,
                    zIndex: 10,
                    cursor: 'grab',
                    ':active': { cursor: 'grabbing' },
                }}
            >
                <DragIndicator fontSize="medium" />
            </Box>
            <DocumentTemplateItem {...props} />
        </Grid>
    );
}

function DocumentTemplateItem({ index, item, onUpdate, onRemove, depth }: DocumentTemplateItemProps) {
    if (item.kind === FormItemKind.FIELD) {
        return <DocumentTemplateField index={index} field={item as FormFieldDto} />;
    } else if (item.kind === FormItemKind.SECTION) {
        return (
            <DocumentTemplateSection
                index={index}
                section={item as DynamicSectionDto}
                onUpdate={onUpdate}
                onRemove={onRemove}
                depth={depth}
            />
        );
    }
    return null;
}
